// extracted by mini-css-extract-plugin
module.exports = {"avatarBase":"AvatarBase_avatarBase__wW9A7","avatarImage":"AvatarBase_avatarImage__L1AF_","signature":"AvatarBase_signature__un83w","dimmed":"AvatarBase_dimmed__V1V0l"};